import React from 'react';
import MaintenanceComponent from '../../fuse-base/components/maintenanceComponent';

const MaintenancePage = () => <MaintenanceComponent />;

export default MaintenancePage;
